import * as React from 'react';
import { Radio } from '@leagueplatform/genesis-core';
import type { ParentId } from '@web-config-app/core';

export type PassIdFunction = (id: ParentId) => void;

export interface DataPointRadioItemProps {
  id: ParentId;
  label: string;
  parentId?: ParentId;
  selectedDataPoint?: ParentId;
  onSelectItem: PassIdFunction;
  itemId: string;
}

/**
 * Renders a selectable data point item as a radio button for single selection mode.
 * Shows the data point label with its ID as a hint below.
 */
export const DataPointRadioItem: React.FC<DataPointRadioItemProps> = ({
  id,
  label,
  parentId,
  selectedDataPoint,
  onSelectItem,
  itemId,
}) => (
  <Radio
    checked={id === selectedDataPoint}
    css={{
      '> label': {
        width: '100%',
      },
    }}
    id={itemId}
    label={label}
    name={parentId || 'category'}
    onChange={() => onSelectItem(id)}
    value={itemId}
    hint={id}
  />
);
